<div @slideInStagger>
  <div class="row mt-4 slide-in-animation">
    <div class="col-md-12">
      <table class="table table-material box-shadow-hover table-responsive-sm">
        <thead class="thead-normal">
        <tr>
          <th class="text-center">{{"to_generate.column.project"|translate}}</th>
          <th class="text-center">{{"to_generate.column.purchase_order"|translate}}</th>
          <th>{{"to_generate.column.client"|translate}}</th>
          <th class="text-center">{{"to_generate.column.type"|translate}}</th>
          <th class="text-center">{{"to_generate.column.description"|translate}}</th>
          <th class="text-center">{{"to_generate.column.action"|translate}}</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let duePayment of listContent">
          <td class="text-center">
            {{ duePayment.projectName }}
          </td>
          <td class="text-center">
            {{ duePayment.purchaseOrderNumber }}
          </td>
          <td>
            {{ duePayment.buyerName }}
          </td>
          <td class="text-center">
            {{ duePayment.type }}
          </td>
          <td class="text-center">
            {{
            duePayment.type == "DATE"
              ? (duePayment.dueDate | date: "dd/MM/yyyy")
              : duePayment.event
            }}
          </td>

          <td class="text-center">
            <isp-button
              class="px-1"
              [type]="ButtonTypeEnum.ICON"
              [icon]="faPenToSquare"
              [colour]="IspColoursEnum.primary"
              [size]="SizeEnum.xs"
              [tooltip]="(!requestBlocked.includes(duePayment.requestId) ? 'to_generate.button_generate':'to_generate.waiting_amendment')|translate"
              [disabled]="requestBlocked.includes(duePayment.requestId)"
              (trigger)="!requestBlocked.includes(duePayment.requestId) ? generateInvoice(duePayment) : null"
            ></isp-button>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>


</div>
